import { defaultFlyoutConfig as foundationConfig, Flyout as FoundationFlyout, foundationFlyoutShadowOptions, } from '@genesislcap/foundation-ui';
import { zeroFlyoutStyles } from './flyout.styles';
import { zeroFlyoutTemplate as template } from './flyout.template';
export const defaultFlyoutConfig = foundationConfig;
export const zeroFlyoutShadowOptions = foundationFlyoutShadowOptions;
/**
 * @tagname %%prefix%%-flyout
 */
export class Flyout extends FoundationFlyout {
}
/**
 * The Zero Flyout
 *
 * @public
 * @remarks
 * HTML Element: \<zero-flyout\>
 */
export const zeroFlyout = Flyout.compose(Object.assign({ baseName: 'flyout', shadowOptions: zeroFlyoutShadowOptions, styles: zeroFlyoutStyles, template }, defaultFlyoutConfig));
